// extracted by mini-css-extract-plugin
export default {"btn":"socialLink_btn__OnZ+d"};